import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeModeProvider } from './contexts/ThemeModeContext';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import MainLayout from './components/Layout/MainLayout';
import Login from './components/Login/Login';
import Dashboard from './components/Dashboard/Dashboard';
import Users from './components/Users/Users';
import Beneficiaries from './components/Beneficiaries/Beneficiaries';
import InvoiceList from './components/Invoices/InvoiceList';
import CreateInvoice from './components/Invoices/CreateInvoice';
import InvoiceDetail from './components/Invoices/InvoiceDetail';
import ExhibitionList from './components/Exhibition/ExhibitionList';
import ExhibitionForm from './components/Exhibition/ExhibitionForm';
import ExhibitionDetail from './components/Exhibition/ExhibitionDetail';
import POList from './components/PurchaseOrders/POList';
import CreatePO from './components/PurchaseOrders/CreatePO';
import PODetail from './components/PurchaseOrders/PODetail';
import ShippingInvoiceList from './components/ShippingInvoices/ShippingInvoiceList';
import CreateShippingInvoice from './components/ShippingInvoices/CreateShippingInvoice';
import ShippingInvoiceDetail from './components/ShippingInvoices/ShippingInvoiceDetail';
import RemittanceList from './components/Remittances/RemittanceList';
import CreateRemittance from './components/Remittances/CreateRemittance';
import RemittanceDetail from './components/Remittances/RemittanceDetail';
import BOEList from './components/BOE/BOEList';
import BOEDetail from './components/BOE/BOEDetail';
import HistoricalBOEList from './components/HistoricalBOE/HistoricalBOEList';
import HistoricalBOEDetail from './components/HistoricalBOE/HistoricalBOEDetail';
import Reports from './components/Reports/Reports';
import ReportsNew from './components/Reports/ReportsNew';
import Certifications from './components/Certifications/Certifications';
import ActivityLog from './components/ActivityLog/ActivityLog';
import OrdersToPlace from './components/Sourcing/OrdersToPlace';
import SupplierDiscovery from './components/Sourcing/SupplierDiscovery';
import OrderDetail from './components/Sourcing/OrderDetail';
import SupplierDetail from './components/Sourcing/SupplierDetail';
import ProductSearches from './components/Sourcing/ProductSearches';
import ProductSearchDetail from './components/Sourcing/ProductSearchDetail';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return null;
  return user ? children : <Navigate to="/login" replace />;
};

const AppRoutes = () => {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<PrivateRoute><MainLayout /></PrivateRoute>}>
        <Route index element={<Dashboard />} />
        <Route path="users" element={<Users />} />
        <Route path="beneficiaries" element={<Beneficiaries />} />
        <Route path="invoices" element={<InvoiceList />} />
        <Route path="invoices/new" element={<CreateInvoice />} />
        <Route path="invoices/:id" element={<InvoiceDetail />} />
        <Route path="invoices/:id/edit" element={<CreateInvoice />} />
        <Route path="sourcing/exhibition" element={<ExhibitionList />} />
        <Route path="sourcing/exhibition/new" element={<ExhibitionForm />} />
        <Route path="sourcing/exhibition/:id" element={<ExhibitionDetail />} />
        <Route path="sourcing/exhibition/:id/edit" element={<ExhibitionForm />} />
        <Route path="purchase-orders" element={<POList />} />
        <Route path="purchase-orders/new" element={<CreatePO />} />
        <Route path="purchase-orders/:id" element={<PODetail />} />
        <Route path="purchase-orders/:id/edit" element={<CreatePO />} />
        <Route path="shipping-invoices" element={<ShippingInvoiceList />} />
        <Route path="shipping-invoices/new" element={<CreateShippingInvoice />} />
        <Route path="shipping-invoices/:id" element={<ShippingInvoiceDetail />} />
        <Route path="shipping-invoices/:id/edit" element={<CreateShippingInvoice />} />
        <Route path="remittances" element={<RemittanceList />} />
        <Route path="remittances/new" element={<CreateRemittance />} />
        <Route path="remittances/:id" element={<RemittanceDetail />} />
        <Route path="boe" element={<BOEList />} />
        <Route path="boe/:id" element={<BOEDetail />} />
        <Route path="historical-boe" element={<HistoricalBOEList />} />
        <Route path="historical-boe/:id" element={<HistoricalBOEDetail />} />
        <Route path="reports" element={<Reports />} />
        <Route path="reports2" element={<ReportsNew />} />
        <Route path="certifications" element={<Certifications />} />
        <Route path="activity-log" element={<ActivityLog />} />
        <Route path="sourcing/orders"       element={<OrdersToPlace />} />
        <Route path="sourcing/orders/:id"   element={<OrderDetail />} />
        <Route path="sourcing/discover"     element={<SupplierDiscovery />} />
        <Route path="sourcing/discover/:id" element={<SupplierDetail />} />
        <Route path="sourcing/searches"     element={<ProductSearches />} />
        <Route path="sourcing/searches/:id" element={<ProductSearchDetail />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default function App() {
  return (
    <ThemeModeProvider>
      <AuthProvider>
        <BrowserRouter basename={process.env.NODE_ENV === 'production' ? '/IdentiumFx' : ''}>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </ThemeModeProvider>
  );
}
